<template>
  <div class="customer-detail">
    <v-row class="py-2">
      <!-- Column 1 (Left Grid): Claim Information & Employee Info -->
      <v-col cols="12" md="6" class="py-0">
        <div class="d-flex flex-column">
          <!-- Section Header: Claim Information -->
          <div class="d-flex align-items-center py-2 mb-1 border-bottom">
            <v-icon small color="indigo darken-4" class="mr-2"
              >mdi-information-outline</v-icon
            >
            <span
              class="font-weight-bold text-uppercase font-size-13 indigo--text text--darken-4"
            >
              CLAIM INFORMATION
            </span>
          </div>

          <!-- Customer -->
          <div
            v-if="
              claim &&
              (claim.expense_category == 3 || claim.expense_category == 4)
            "
            class="d-flex align-items-center justify-content-between py-2 border-bottom"
          >
            <div class="d-flex align-items-center">
              <v-icon v-if="false" small color="indigo darken-4" class="mr-2"
                >mdi-account-outline</v-icon
              >
              <span class="text-secondary font-weight-500 font-size-18"
                >Customer</span
              >
            </div>
            <span class="font-size-18 text-dark text-capitalize">
              <template v-if="claim?.customer?.company_name">{{
                claim.customer.company_name
              }}</template>
              <template v-else
                ><em class="text-muted font-weight-normal"
                  >no customer</em
                ></template
              >
            </span>
          </div>

          <!-- Category -->
          <div
            class="d-flex align-items-center justify-content-between py-2 border-bottom"
          >
            <div class="d-flex align-items-center">
              <v-icon v-if="false" small color="indigo darken-4" class="mr-2"
                >mdi-tag-outline</v-icon
              >
              <span class="text-secondary font-weight-500 font-size-18"
                >Category</span
              >
            </div>
            <span class="font-size-18 text-dark text-capitalize">
              <template v-if="claim?.claim_category">{{
                claim.claim_category
              }}</template>
              <template v-else
                ><em class="text-muted font-weight-normal"
                  >no category</em
                ></template
              >
            </span>
          </div>

          <!-- Sub-Category -->
          <div
            class="d-flex align-items-center justify-content-between py-2 border-bottom"
          >
            <div class="d-flex align-items-center">
              <v-icon v-if="false" small color="indigo darken-4" class="mr-2"
                >mdi-shape-outline</v-icon
              >
              <span class="text-secondary font-weight-500 font-size-18"
                >Sub-Category</span
              >
            </div>
            <span class="font-size-18 text-dark text-capitalize">
              <template v-if="claim?.claim_subcategory">{{
                claim.claim_subcategory
              }}</template>
              <template v-else
                ><em class="text-muted font-weight-normal"
                  >no subcategory</em
                ></template
              >
            </span>
          </div>

          <!-- Payment Mode -->
          <div
            class="d-flex align-items-center justify-content-between py-2 border-bottom"
          >
            <div class="d-flex align-items-center">
              <v-icon v-if="false" small color="indigo darken-4" class="mr-2"
                >mdi-credit-card-outline</v-icon
              >
              <span class="text-secondary font-weight-500 font-size-18"
                >Payment Mode</span
              >
            </div>
            <span class="font-size-18 text-dark text-capitalize">
              <template v-if="claim?.payment_mode_name">{{
                claim.payment_mode_name
              }}</template>
              <template v-else
                ><em class="text-muted font-weight-normal"
                  >no payment mode</em
                ></template
              >
            </span>
          </div>

          <!-- Claim Date -->
          <div
            class="d-flex align-items-center justify-content-between py-2 border-bottom"
          >
            <div class="d-flex align-items-center">
              <v-icon v-if="false" small color="indigo darken-4" class="mr-2"
                >mdi-calendar-outline</v-icon
              >
              <span class="text-secondary font-weight-500 font-size-18"
                >Claim Date</span
              >
            </div>
            <span class="font-size-18 text-dark">
              <template v-if="claim?.expense_date">{{
                formatDate(claim.expense_date)
              }}</template>
              <template v-else
                ><em class="text-muted font-weight-normal"
                  >no date</em
                ></template
              >
            </span>
          </div>

          <!-- SBU -->
          <div
            class="d-flex align-items-center justify-content-between py-2 mb-3"
          >
            <div class="d-flex align-items-center">
              <v-icon v-if="false" small color="indigo darken-4" class="mr-2"
                >mdi-domain</v-icon
              >
              <span class="text-secondary font-weight-500 font-size-18"
                >SBU</span
              >
            </div>
            <span class="font-size-18 text-dark text-capitalize">
              <template v-if="claim?.sbu_name">{{ claim.sbu_name }}</template>
              <template v-else
                ><em class="text-muted font-weight-normal">no sbu</em></template
              >
            </span>
          </div>

          <!-- Section Header: Employee Information -->
          <div class="d-flex align-items-center py-2 mb-1 border-bottom">
            <v-icon small color="indigo darken-4" class="mr-2"
              >mdi-account-tie-outline</v-icon
            >
            <span
              class="font-weight-bold text-uppercase font-size-13 indigo--text text--darken-4"
            >
              EMPLOYEE INFORMATION
            </span>
          </div>

          <!-- Employee -->
          <div
            class="d-flex align-items-center justify-content-between py-2 border-bottom"
          >
            <div class="d-flex align-items-center">
              <v-icon v-if="false" small color="indigo darken-4" class="mr-2"
                >mdi-account-outline</v-icon
              >
              <span class="text-secondary font-weight-500 font-size-18"
                >Employee</span
              >
            </div>
            <span class="font-size-18 text-dark text-capitalize">
              <template v-if="claim.employee && claim.employee.display_name">
                {{ claim.employee.display_name }}
              </template>
              <template v-else
                ><em class="text-muted font-weight-normal"
                  >no employee</em
                ></template
              >
            </span>
          </div>

          <!-- Designation -->
          <div class="d-flex align-items-center justify-content-between py-2">
            <div class="d-flex align-items-center">
              <v-icon v-if="false" small color="indigo darken-4" class="mr-2"
                >mdi-briefcase-outline</v-icon
              >
              <span class="text-secondary font-weight-500 font-size-18"
                >Designation</span
              >
            </div>
            <span class="font-size-18 text-dark text-capitalize">
              <template v-if="claim.employee && claim.employee.designation">
                {{ claim.employee.designation.text }}
              </template>
              <template v-else
                ><em class="text-muted font-weight-normal"
                  >no designation</em
                ></template
              >
            </span>
          </div>
        </div>
      </v-col>

      <!-- Column 2 (Right Grid): Vendor, Receipts & System Information -->
      <v-col cols="12" md="6" class="py-0 pl-md-6 border-left-md">
        <div class="d-flex flex-column">
          <!-- Section Header: Vendor & Receipts -->
          <div class="d-flex align-items-center py-2 mb-1 border-bottom">
            <v-icon small color="indigo darken-4" class="mr-2"
              >mdi-store-outline</v-icon
            >
            <span
              class="font-weight-bold text-uppercase font-size-13 indigo--text text--darken-4"
            >
              VENDOR & RECEIPTS
            </span>
          </div>

          <!-- Vendor -->
          <div
            class="d-flex align-items-center justify-content-between py-2 border-bottom"
          >
            <div class="d-flex align-items-center">
              <v-icon v-if="false" small color="indigo darken-4" class="mr-2"
                >mdi-account-group-outline</v-icon
              >
              <span class="text-secondary font-weight-500 font-size-18"
                >Vendor</span
              >
            </div>
            <span class="font-size-18 text-dark text-capitalize">
              <template v-if="claim?.vendor_name">{{
                claim.vendor_name
              }}</template>
              <template v-else
                ><em class="text-muted font-weight-normal"
                  >no vendor</em
                ></template
              >
            </span>
          </div>

          <!-- Receipt Number -->
          <div
            class="d-flex align-items-center justify-content-between py-2 mb-3"
          >
            <div class="d-flex align-items-center">
              <v-icon v-if="false" small color="indigo darken-4" class="mr-2"
                >mdi-receipt</v-icon
              >
              <span class="text-secondary font-weight-500 font-size-18"
                >Receipt Number</span
              >
            </div>
            <span class="font-size-18 text-dark font-weight-medium">
              <template v-if="claim?.receipt_number">{{
                claim.receipt_number
              }}</template>
              <template v-else
                ><em class="text-muted font-weight-normal"
                  >no receipt</em
                ></template
              >
            </span>
          </div>

          <!-- Section Header: System Information -->
          <div class="d-flex align-items-center py-2 mb-1 border-bottom">
            <v-icon small color="indigo darken-4" class="mr-2"
              >mdi-cog-outline</v-icon
            >
            <span
              class="font-weight-bold text-uppercase font-size-13 indigo--text text--darken-4"
            >
              SYSTEM INFORMATION
            </span>
          </div>

          <!-- Added By -->
          <div
            class="d-flex align-items-center justify-content-between py-2 border-bottom"
          >
            <div class="d-flex align-items-center">
              <v-icon v-if="false" small color="indigo darken-4" class="mr-2"
                >mdi-account-edit-outline</v-icon
              >
              <span class="text-secondary font-weight-500 font-size-18"
                >Added By</span
              >
            </div>
            <span class="font-size-18 text-dark text-capitalize">
              <template v-if="claim?.added_by?.display_name">{{
                claim.added_by.display_name
              }}</template>
              <template v-else
                ><em class="text-muted font-weight-normal"
                  >no data</em
                ></template
              >
            </span>
          </div>

          <!-- Created Date -->
          <div class="d-flex align-items-center justify-content-between py-2">
            <div class="d-flex align-items-center">
              <v-icon v-if="false" small color="indigo darken-4" class="mr-2"
                >mdi-clock-outline</v-icon
              >
              <span class="text-secondary font-weight-500 font-size-18"
                >Created Date</span
              >
            </div>
            <span class="font-size-18 text-dark">
              <template v-if="claim?.added_at">{{
                formatDateTime(claim.added_at)
              }}</template>
              <template v-else
                ><em class="text-muted font-weight-normal"
                  >no date</em
                ></template
              >
            </span>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Description Card Section -->
    <v-row class="mt-2">
      <v-col cols="12" class="pt-0">
        <v-card flat class="border rounded-lg p-3 bg-light">
          <div class="d-flex align-items-center mb-2">
            <v-icon small color="indigo darken-4" class="mr-2"
              >mdi-text-box-outline</v-icon
            >
            <span
              class="font-weight-bold text-uppercase font-size-13 indigo--text text--darken-4"
            >
              DESCRIPTION
            </span>
          </div>
          <p class="mb-0 font-size-18 text-dark">
            <template v-if="claim?.note">{{ claim.note }}</template>
            <em v-else class="text-muted font-weight-normal">no description</em>
          </p>
        </v-card>
      </v-col>
    </v-row>

    <!-- General Remark Section -->
    <v-row
      v-if="claim.general_remark && (claim.status == 2 || claim.status == 3)"
      class="mt-1"
    >
      <v-col cols="12" class="pt-0">
        <v-card
          flat
          class="border rounded-lg p-3"
          :class="claim.status == 2 ? 'bg-light-success' : 'bg-light-danger'"
        >
          <div class="d-flex align-items-center mb-2">
            <v-icon
              small
              :color="claim.status == 2 ? 'success' : 'danger'"
              class="mr-2"
            >
              {{
                claim.status == 2
                  ? "mdi-check-circle-outline"
                  : "mdi-close-circle-outline"
              }}
            </v-icon>
            <span
              class="font-weight-bold text-uppercase font-size-13"
              :class="claim.status == 2 ? 'text-success' : 'text-danger'"
            >
              {{ claim.status == 2 ? "ACCEPTED" : "REJECTED" }} REMARK
            </span>
          </div>
          <p class="mb-0 font-size-18 text-dark font-weight-medium">
            {{ claim.general_remark }}
          </p>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";

export default {
  name: "claim-overview",
  mixins: [CommonMixin],

  props: {
    claim: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  computed: {
    getClaimTypeDisplay() {
      if (!this.claim.related_type || this.claim.related_type === "-") {
        return "Not Available";
      }
      return this.claim.related_type;
    },

    getClaimTypeColor() {
      const colorMap = {
        Lead: "primary",
        Visit: "success",
        Customer: "purple",
      };
      return colorMap[this.claim.related_type] || "grey";
    },
  },

  methods: {
    formatAmount(amount) {
      if (!amount) return "0.00";
      return parseFloat(amount).toFixed(2);
    },
  },
};
</script>
